import { userApi } from "../../../config";

export const fetchInstructors = async () => {
    try {
        const res = await userApi.get("/view-homepage-instructors");
        return res.data;
    }catch (err) {
    }
}

export const fetchInstructorsByRole = async (role: string): Promise<any> => {
    try {
        const res = await userApi.get(`/view-instructors-by-role?role=${role}`);
        return res.data;
    } catch (err) {
        console.error("Error fetching instructors by role:", err);
        return { data: [] };
    }
}